export default "__VITE_ASSET__BK1HuMdx__"